import { DATA_PRIVACY_PRODUCT_ID } from './constants';
import { getLoginUserId } from './index';

// Compare button tour (Data Privacy only) — hardcoded on the frontend, gated per logged-in
// user via localStorage rather than the userGuideStatus API. Kept dependency-free (no shepherdTour
// or services imports) so authService's customLogout (which does a blanket localStorage.clear())
// can preserve this flag across logout without creating a circular import.
export const COMPARE_TOUR_SEEN_STORAGE_PREFIX = 'aos_compare_tour_seen_';

const hasSeenCompareTour = (userId: string): boolean =>
  localStorage.getItem(`${COMPARE_TOUR_SEEN_STORAGE_PREFIX}${userId}`) === 'true';

/** Marks the Compare tour as seen for this logged-in user so it never shows again on this browser. */
export const markCompareTourSeen = (userId: string): void => {
  localStorage.setItem(`${COMPARE_TOUR_SEEN_STORAGE_PREFIX}${userId}`, 'true');
};

/** True only for the Data Privacy product, for a logged-in user who hasn't seen it yet. */
export const shouldShowCompareTour = (productId: number | undefined): boolean => {
  if (productId !== DATA_PRIVACY_PRODUCT_ID) {
    return false;
  }
  const userId = getLoginUserId();
  if (!userId) {
    return false;
  }
  return !hasSeenCompareTour(userId);
};
